/* VISTAS HACE POCO · 27-ago-2026
 *
 * 🔴 POR QUÉ, si ninguna de las tres tiendas medidas lo tiene. Porque el
 * catálogo es CHICO y muy parejo: la clienta rebota entre tres vestidos
 * negros parecidos y, cuando quiere volver al segundo, ya no sabe cuál era.
 * En un catálogo de miles esto sobra —por eso Toteme no lo pone—; en uno de 54
 * prendas casi idénticas es la diferencia entre comparar y rendirse.
 *
 * 🔴 LA TARJETA NO SE REESCRIBE EN JAVASCRIPT. Se pide a
 * `/products/<handle>?view=tarjeta`, que devuelve exactamente la misma
 * `avora-pieza` del catálogo. Dibujarla a mano aquí habría creado una segunda
 * tarjeta que se desincroniza al primer cambio —los puntos de color, las
 * tallas tachadas— y en silencio. Ver `templates/product.tarjeta.liquid`.
 *
 * 🔴 NO SE REPITE LO QUE YA ESTÁ ARRIBA. Se leen los enlaces de los otros dos
 * módulos y se descartan: tres filas con la misma prenda se ve descuidado.
 *
 * 🔴 FAIL-VISIBLE. El bloque nace `hidden` en el HTML. Si el JS no corre, o si
 * es la primera visita y no hay historial, no queda un rótulo con un hueco
 * debajo: simplemente no existe.
 */
(function () {
  var caja = document.querySelector('[data-vistas]');
  var LLAVE = 'avora:vistas';
  var TOPE_MEMORIA = 12;   /* cuántas se recuerdan */
  var TOPE_FILA = 4;       /* cuántas se pintan */

  /* El handle de la prenda actual sale del `<link rel=canonical>`, que Shopify
     escribe siempre. Leerlo de `location.pathname` fallaba con `?variant=` y
     con el `?preview_theme_id=` de la vista previa. */
  function handleActual() {
    var c = document.querySelector('link[rel="canonical"]');
    var ruta = c ? c.getAttribute('href') : location.href;
    var m = ruta.match(/\/products\/([^/?#]+)/);
    return m ? m[1] : '';
  }

  var mio = handleActual();
  if (!mio) return;

  /* ---------- recordar ---------- */
  var lista = [];
  try { lista = JSON.parse(localStorage.getItem(LLAVE) || '[]'); } catch (e) { lista = []; }
  if (!Array.isArray(lista)) lista = [];

  /* La actual va al frente y sin duplicar: si vuelve a una prenda, sube. */
  lista = lista.filter(function (h) { return h && h !== mio; });
  lista.unshift(mio);
  lista = lista.slice(0, TOPE_MEMORIA);
  try { localStorage.setItem(LLAVE, JSON.stringify(lista)); } catch (e) { /* modo privado */ }

  if (!caja) return;

  /* ---------- pintar ---------- */
  var yaArriba = {};
  [].slice.call(document.querySelectorAll('.f-sug a[href*="/products/"]')).forEach(function (a) {
    var m = a.getAttribute('href').match(/\/products\/([^/?#]+)/);
    if (m) yaArriba[m[1]] = true;
  });

  var pendientes = lista.filter(function (h) {
    return h !== mio && !yaArriba[h];
  }).slice(0, TOPE_FILA);

  if (!pendientes.length) return;

  /* La vista previa del borrador vive tras `?preview_theme_id=`: sin arrastrarlo
     la tarjeta llegaría del tema PUBLICADO. Misma trampa que en el catálogo. */
  var prev = new URL(location.href).searchParams.get('preview_theme_id');
  function conVistaPrevia(u) {
    return prev ? u + '&preview_theme_id=' + encodeURIComponent(prev) : u;
  }

  var fila = caja.querySelector('[data-vistas-fila]');

  Promise.all(pendientes.map(function (h) {
    return fetch(conVistaPrevia('/products/' + h + '?view=tarjeta'))
      .then(function (r) { return r.ok ? r.text() : ''; })
      .catch(function () { return ''; });
  })).then(function (trozos) {
    var puestas = 0;
    trozos.forEach(function (html) {
      if (!html) return;
      var d = new DOMParser().parseFromString(html, 'text/html');
      var art = d.querySelector('.p-pieza');
      if (!art) return;
      /* `data-visto` a mano: el observador del movimiento ya recorrió la página
         y es ciego a lo que llega después — sin esto la tarjeta se queda 28px
         abajo de su sitio para siempre. */
      art.setAttribute('data-visto', '');
      fila.appendChild(art);
      puestas++;
    });
    /* 🔴 AQUÍ SÍ VALE UNA SOLA. En los otros dos módulos una tarjeta suelta se
       ve pobre porque son una PROPUESTA; este es un HISTORIAL, y volver a la
       prenda anterior es útil aunque solo haya una. Con el umbral en 2 el
       bloque no aparecía hasta la tercera prenda vista — y para entonces ya
       hacía falta. La rejilla es de 4 columnas fijas, así que una tarjeta sola
       conserva su tamaño y no se estira. */
    if (puestas > 0) caja.hidden = false;
  });
})();
